import React from 'react';
import { IHSANROLL_OFFICERS } from '../../data/ihsanRollMock';

export default function OfficerSheet({ current, onPick, onDismiss }) {
  return (
    <div
      className="fixed inset-0 z-[80] bg-black/40 flex items-end md:items-center md:justify-center"
      role="dialog"
      aria-modal="true"
      aria-label="Select duty officer"
      data-testid="duty-officer-sheet"
    >
      <button
        type="button"
        className="absolute inset-0"
        aria-label="Close"
        onClick={current ? onDismiss : undefined}
      />
      <div className="relative w-full md:max-w-md bg-white rounded-t-2xl md:rounded-2xl p-5 pb-8 shadow-xl">
        <p className="text-lg font-extrabold text-[#0F172A]">Who is on duty?</p>
        <p className="text-sm text-muted-foreground mt-1">
          Every attendance and movement log is stamped with this name. No anonymous entries.
        </p>
        <div className="mt-4 flex flex-col gap-2">
          {IHSANROLL_OFFICERS.map((name) => {
            const active = current === name;
            return (
              <button
                key={name}
                type="button"
                data-testid={`duty-officer-${name.replace(/\s+/g, '-').toLowerCase()}`}
                onClick={() => onPick(name)}
                className={`min-h-[44px] rounded-xl border px-4 text-left text-sm font-semibold transition-colors ${
                  active
                    ? 'border-primary bg-primary/5 text-primary'
                    : 'border-border text-[#0F172A] hover:bg-muted/40'
                }`}
              >
                {name}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
